export enum PlayerAiTrendsEnum {
  STRENGTH,
  LIGHTWEIGHT,
  AGILITY,
  STIFFNESS,
  ENDURANCE,
  LOW_STAMINA,
  SPEED,
  SLUGGISHNESS,
  RECOVERY,
  DEPLETION,
  POWER,
  DELICACY,
  CONSISTENCY,
  VARIABILITY,
  WORKRATE,
  LAZINESS,
  INTENSITY,
  EASE
} 